import { useState, useCallback } from 'react';
export function useConversation() {
    const [messages, setMessages] = useState([]);
    const [isListening, setIsListening] = useState(false);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const addMessage = useCallback((message) => {
        const newMessage = {
            ...message,
            id: `msg-${Date.now()}-${Math.random()}`,
            timestamp: new Date(),
        };
        setMessages((prev) => [...prev, newMessage]);
    }, []);
    const sendMessage = useCallback((content) => {
        addMessage({
            role: 'user',
            content,
        });
    }, [addMessage]);
    const receiveMessage = useCallback((content) => {
        addMessage({
            role: 'assistant',
            content,
        });
    }, [addMessage]);
    const clearMessages = useCallback(() => {
        setMessages([]);
    }, []);
    return {
        messages,
        isListening,
        isSpeaking,
        setIsListening,
        setIsSpeaking,
        sendMessage,
        receiveMessage,
        clearMessages,
    };
}
